import { PortfoliosCommandsService_portfolioCommandsServiceGetEntities } from '@festina/unitlink-general-types/unitlink/hooks/PortfoliosCommandsService_portfolioCommandsServiceGetEntities'

export const useFetchPortfolioCommands =
  PortfoliosCommandsService_portfolioCommandsServiceGetEntities.useSuspenseQuery
